// Strips attributes referencing the file:// scheme (e.g. images pasted from Word/Outlook
// into LibCal) which browsers block, throwing "Content may not load or link to file:///".
export function stripFileLinks(html) {
  if (!html) return html;

  const doc = new DOMParser().parseFromString(html, 'text/html');

  doc.body.querySelectorAll('*').forEach((el) => {
    ['src', 'href', 'poster', 'background'].forEach((attr) => {
      const value = el.getAttribute(attr);
      if (value && value.trim().toLowerCase().startsWith('file://')) {
        el.removeAttribute(attr);
      }
    });
  });

  return doc.body.innerHTML;
}
